var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.56039 10.1196H3.12039V6.03961C3.12039 4.22673 4.48039 3.31961 5.83971 3.31961H5.84107C7.20039 3.31961 8.56039 4.22673 8.56039 6.03961V10.1196ZM6.52039 12.1596C6.52039 12.535 6.21575 12.8396 5.84039 12.8396C5.46503 12.8396 5.16039 12.535 5.16039 12.1596V11.4796H6.52039V12.1596ZM9.92039 9.43961V6.03961C9.92039 3.62357 8.31015 2.28261 6.52039 2.01333V0.599609H5.16039V2.01333C3.37063 2.28261 1.76039 3.62357 1.76039 6.03961V9.43961C1.76039 9.81497 1.45575 10.1196 1.08039 10.1196C0.705031 10.1196 0.400391 10.4242 0.400391 10.7996C0.400391 11.175 0.705031 11.4796 1.08039 11.4796H3.80039V12.1596C3.80039 13.2864 4.71363 14.1996 5.84039 14.1996C6.96715 14.1996 7.88039 13.2864 7.88039 12.1596V11.4796H10.6004C10.9758 11.4796 11.2804 11.175 11.2804 10.7996C11.2804 10.4242 10.9758 10.1196 10.6004 10.1196C10.225 10.1196 9.92039 9.81497 9.92039 9.43961Z",
    fill: "#AAB5C5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_524_25000",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 12,
    height: 15
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.56039 10.1196H3.12039V6.03961C3.12039 4.22673 4.48039 3.31961 5.83971 3.31961H5.84107C7.20039 3.31961 8.56039 4.22673 8.56039 6.03961V10.1196ZM6.52039 12.1596C6.52039 12.535 6.21575 12.8396 5.84039 12.8396C5.46503 12.8396 5.16039 12.535 5.16039 12.1596V11.4796H6.52039V12.1596ZM9.92039 9.43961V6.03961C9.92039 3.62357 8.31015 2.28261 6.52039 2.01333V0.599609H5.16039V2.01333C3.37063 2.28261 1.76039 3.62357 1.76039 6.03961V9.43961C1.76039 9.81497 1.45575 10.1196 1.08039 10.1196C0.705031 10.1196 0.400391 10.4242 0.400391 10.7996C0.400391 11.175 0.705031 11.4796 1.08039 11.4796H3.80039V12.1596C3.80039 13.2864 4.71363 14.1996 5.84039 14.1996C6.96715 14.1996 7.88039 13.2864 7.88039 12.1596V11.4796H10.6004C10.9758 11.4796 11.2804 11.175 11.2804 10.7996C11.2804 10.4242 10.9758 10.1196 10.6004 10.1196C10.225 10.1196 9.92039 9.81497 9.92039 9.43961Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_524_25000)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -3.59961,
    y: -1.80078,
    width: 19.2,
    height: 19.2,
    fill: "#8CAEB4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/Notification-icon.ba384fcf47faa82d46db6dc13691765f.svg";
export { ForwardRef as ReactComponent };